<template>
  <div class="footer-box">
    <el-row style="width: 90%;margin: 0 auto">
      <el-col :xs="24" :sm="4" class="d-table">
        <div class="qr-box"><img src="../assets/img/footer/qr-code.png">
          <p class="font20">扫码，关注我们</p></div>
      </el-col>
      <el-col :xs="24" :sm="16" class="d-table">
        <div class="footer-text">
          <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">
              济南市数科职业中等专业学校有限公司（简称济南市数科职业中等专业学校）         版权所有 鲁ICP备2025170709号-1</a>
          <p>地址：济南市章丘区刁镇柴家小庄北街18号</p></div>
      </el-col>
      <el-col :xs="24" :sm="4" class="d-table">
         <!-- <div class="ssl-box">
          <a href="https://xyt.xcc.cn/getpcInfo?sn=1770415919235842048&certType=8&url=www.xktech.com&language=CN" target="_blank">
            <img src="https://xyt.xinchacha.com/img/icon/icon8.png" style="height:50px;width:164px;">
          </a>
        </div> -->
       
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: "MyFooter"
  }
</script>

<style scoped>
  .footer-box {
    background: #0d1e3c;
    color: #adb1bd;
    height: 200px;
    box-sizing: border-box;
  }

  .d-table {
    display: table;
  }

  .footer-text {
    display: table-cell;
    vertical-align: middle;
    text-align: center;
    height: 200px;
    color: #fff;
  }
  .footer-text a{
    color: #fff;
  }

  .qr-box {
    display: table-cell;
    vertical-align: middle;
    text-align: center;
    height: 200px;
    width: 200px;
  }

  .qr-box > img {
    display: block;
    margin: 0 auto;
  }

  .qr-box > p {
    text-align: center;
    margin-top: 10px;
    color: #fff;
  }

  .ssl-box {
    display: table-cell;
    vertical-align: middle;
    text-align: center;
    height: 200px;
  }

  .ssl-box > img {
    display: block;
    margin: 0 auto;
  }
  @media only screen and (max-width: 768px) {
    .footer-box{
      height:400px;
    }
    .footer-text {
      height: 100px;
    }
    .ssl-box{
      height: 100px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/MyFooter.vue